export default __webpack_public_path__ + "static/media/twitter.59605c06.svg";